import { IProfitPreviewDTO } from "@hooks/dtos/profit/IProfitPreviewDTO";
import { api } from "@service/api";
import { useEffect, useState } from "react";

type ProfitPreviewParams = {
  profitId?: number;
  paymentMethod?: number;
  ticketAmount: number;
  ticketPrice: number;
};

type ProfitPreviewState = {
  data?: IProfitPreviewDTO;
  isLoading: boolean;
  error?: string;
};

export function useProfitPreview({
  profitId,
  paymentMethod = 1,
  ticketAmount,
  ticketPrice,
}: ProfitPreviewParams): ProfitPreviewState {
  const [state, setState] = useState<ProfitPreviewState>({
    isLoading: false,
  });

  useEffect(() => {
    if (!profitId || ticketAmount <= 0 || ticketPrice <= 0) {
      setState({ isLoading: false });
      return;
    }

    let isCurrent = true;
    const timer = window.setTimeout(async () => {
      setState((previous) => ({ ...previous, isLoading: true, error: undefined }));

      try {
        const params = new URLSearchParams({
          profitId: String(profitId),
          paymentMethod: String(paymentMethod),
          ticketAmount: String(ticketAmount),
          ticketPrice: String(ticketPrice),
        });
        const response = await api.get<IProfitPreviewDTO>(
          `/customer/raffle/default/my/profit/preview?${params.toString()}`,
        );

        if (isCurrent) {
          setState({ data: response.data, isLoading: false });
        }
      } catch (error: any) {
        if (isCurrent) {
          setState({
            isLoading: false,
            error:
              error?.response?.data?.message ||
              "Não foi possível atualizar a projeção financeira.",
          });
        }
      }
    }, 350);

    return () => {
      isCurrent = false;
      window.clearTimeout(timer);
    };
  }, [paymentMethod, profitId, ticketAmount, ticketPrice]);

  return state;
}